<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { FwSurfaceCard } from '@fusapp-work/ui-kit'
import type { SurfaceName } from './surfaces'

const props = defineProps<{ surface: SurfaceName }>()
const { t } = useI18n()
const title = `Fusapp Work · ${props.surface}`
</script>

<template>
  <main
    class="fw-app-shell"
    :data-surface="surface"
  >
    <FwSurfaceCard
      :title="title"
      :subtitle="t('shell.subtitle')"
    >
      <slot />
    </FwSurfaceCard>
  </main>
</template>

<style scoped>
.fw-app-shell {
  min-height: 100vh;
  padding: var(--fw-space-md);
  font-family: var(--fw-font-sans);
}
</style>
